import { facultyData } from '../facultyData';

export const statisticsData = {
  departmentName: "Department of Statistics",
  bannerImage: "/statistics/statisticsBanner.JPG",
  
  about: {
    title: "About the Department",
    content: `The Department of Statistics provides quality education in statistical methods, data analysis, 
    operations research, and quality control. We prepare students for careers in data science, analytics, 
    research, and industry.`,
    highlights: [
      "Computer labs with statistical software",
      "Focus on applied statistics",
      "Industry-oriented curriculum",
      "Strong placement in analytics sector"
    ]
  },

  brochure: {
    title: "Department Brochure",
    pdfLink: "/statistics/department-brochure.pdf",
    description: "Download our comprehensive department brochure."
  },

  hod: {
    id:'stat001',
    name: "Dr. Y. Raghunatha Reddy",
    designation: "Co-ordinator & Assistant Professor (C)",
    photo: "/statistics/Ragu.JPG",
    email: "drraghuy@gmail.com",
    mobile: "+91 89858 58282",
    qualification: "M.Sc, Ph.D, MBA",
    specialization: "Operations Research, Statistical Quality Control",
    message: `Welcome to the Department of Statistics. We are committed to excellence in statistical education.`,
    profileLink: "/statistics/yrr.pdf"
  },

  bos: {
  title: "OR & SQC (Statistics)",
  members: [
    {
      name: "Prof. K. Pushpanjali",
      designation: "Chairperson",
      affiliation: "Dept. of Statistics, S.K. University, Ananthapuramu"
    },
    {
      name: "Dr. Sujatha S. Inginshetty",
      designation: "Member",
      affiliation: "Senior Professor & Chairperson, Dept. of Statistics, Gulbarga University, Kalaburagi, Karnataka"
    },
    {
      name: "Prof. B. Sarojamma",
      designation: "Member",
      affiliation: "Dept. of Statistics, S.V. University, Tirupati"
    },
    {
      name: "Prof. B. Muniswamy",
      designation: "Member",
      affiliation: "Andhra University, Visakhapatnam"
    },
    {
      name: "Dr. Ujjal Kumar Behra",
      designation: "Member",
      affiliation: "Superintending Engineer (IE), The Singareni Collieries Company Ltd., Kottagudem, Khammam"
    }
  ]
}
,

  faculty: facultyData.statistics.faculty,

  courses: {
    // undergraduate: [
    //   {
    //     name: "B.Sc. Statistics",
    //     duration: "3 Years",
    //     eligibility: "10+2 with Mathematics",
    //     intake: "60 seats"
    //   }
    // ],
    postgraduate: [
      {
        name: "M.Sc. Statistics",
        duration: "2 Years",
        eligibility: "B.Sc. with Statistics/Mathematics",
        intake: "30 seats"
      }
    ],
    // research: [
    //   {
    //     name: "Ph.D. in Statistics",
    //     duration: "Minimum 3 Years",
    //     eligibility: "M.Sc. Statistics",
    //     areas: "Operations Research, Statistical Quality Control, Data Science"
    //   }
    // ]
  },

   Infrastructure: [
  "/infrastructure/statistics/class-1.JPG",
  "/infrastructure/statistics/class-2.JPG",
  "/infrastructure/statistics/class-3.JPG",
  
]
};
